import styled from '@emotion/styled';
import theme from '../../constants/theme';

type InputProps = {
  fontSize?: string;
  color?: string;
  width?: string;
  shadow?: boolean;
  theme?: typeof theme;
};

const Input = styled.input<InputProps>`
  font-size: ${(props) => (props.fontSize ? props.fontSize : '16px')};
  background: transparent;
  padding: 10px 14px;
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.colors.lightGrey};
  outline: none;
  transition: all 0.1s linear;
  width: ${(props) => (props.width ? props.width : '100%')};
  color: ${(props) => (props.color ? props.color : props.theme.colors.black)};
  box-shadow: ${(props) => (props.shadow ? props.theme.shadows.shadow2 : 'none')};

  &::placeholder {
    color: #c9c9c9;
    font-weight: 400;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export default Input;
